export const DEFAULT_ROUTE = '/';
export const SUPER_ADMIN_ROLE = 'SuperAdmin';
